import React from "react";
import {
  Stack,
  Typography,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ConnectWallet from "../ConnectWallet";

// ---------------------------------------------------------------------
const ContainerStyle = styled("div")(({ theme }) => ({
  padding: "20px",
  borderBottom: "1px solid #ffffff80",
}));

const TitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "70px",
  fontFamily: "Helvetica",
}));

const ContentStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "20px",
  fontFamily: "Helvetica",
  lineHeight: 1.2,
  paddingBottom: "15px",
}));

export default function TeamMobileContent() {
  return (
    <Stack sx={{ mt: "90px" }}>
      <ContainerStyle>
        <TitleStyle sx={{ fontSize: "30px" }}>
          WE ARE A TEAM WITH 100 YEARS COMBINED EXPERIENCE WORKING WITH GLOBAL
          DTC BRANDS CREATING CULTURE
        </TitleStyle>
      </ContainerStyle>
      <Stack>
        <Box
          component="img"
          src="/assets/2-2.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          MABDULLE
          <br />
          Culture-maker
        </ContentStyle>
        <ContentStyle></ContentStyle>
        <ContentStyle>
          East London-born Somali creative Mabdulle, whose gritty portrayal of
          city life has seen him rise from spare-time street shooter to
          full-time photographer and director working with the biggest brands
          and artists around like: Stormzy, Victoria Beckham, Adidas and more.
          Co-Founder of Take More Photos; an online/offline community for
          creatives.
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/KHADIJA-2.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          KHADIJA
          <br />
          Artist Director
        </ContentStyle>
        <ContentStyle>
          West London born Music / talent manager who has used the
          misrepresentation she has experienced in the creative industry to
          carve out a barrier for young talented creatives coming though the
          game. Through her roster she has created a protective blanket between
          brands and creatives allowing them to be represented as they deserve.
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/VIKTORIA.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          VIKTORIA WYCKMAN
          <br />
          CMO & Innovation
        </ContentStyle>
        <ContentStyle>
          Viktoria has 10+ years working with the creator economy for global DTC
          brands including running some of the world’s largest creator programs
          for brands such as: Adobe, Disney, Pernod Ricard, Condé Nast,
          Heineken, Spotify, H&M, Volvo, Google among others.
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/LOAI.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          LOAI
          <br />
          DJ and Creator
        </ContentStyle>
        <ContentStyle>
          I’m a DJ/ Producer from Colindale, Northwest London, very passionate
          about DJing and what it means to me. DJing for me is not just a
          transition from one song to another, it’s an expression. It’s the
          freedom to create an experience completely unique to you. That is
          truly DJing.
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/RHOOD4.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          FLAMIN BEATZ
          <br />
          Music Producer, Sound Engineer & Mentor
        </ContentStyle>
        <ContentStyle>
          I’m a Music Producer/ Sound Engineer & Mentor through music in
          schools. Caribbean descent, born and raised in Leyton, East London.
          Was introverted until music was introduce to me and gave me power to
          communicate through sound and build connections youth in the community
          and artist's all over world.
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/JAMES.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          JAMES
          <br />
          Videographer
        </ContentStyle>
        <ContentStyle>
          I'm James, a filmmaker and photographer in a variety of genres. My
          general motto is 'Make cool shit' and that's what I'm always trying to
          do.
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/JOHAN.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <ContentStyle>
          JOHAN WENDNER
          <br />
          Brand Partnership
        </ContentStyle>
        <ContentStyle>
          Johan has over 10 years’ experience in business development and
          building & managing successful sales teams in the marketing industry.
          But his true passion is the revolution of web3 and crypto. Worked with
          brands including: Volvo, Audi, Facebook, DHL, Oracle among others.
        </ContentStyle>
      </ContainerStyle>
    </Stack>
  );
}
